module.exports = __webpack_public_path__ + "img/bgi.eb2b8f09.jpg";